import { useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

const sampleRecipe = {
  product: "Kaju Katli",
  ingredients: [
    { item: "Kaju", qty: 0.65, unit: "Kg" },
    { item: "Sugar", qty: 0.3, unit: "Kg" },
    { item: "Ghee", qty: 0.05, unit: "Kg" },
  ],
};

export default function ProductionRequest() {
  const [qty, setQty] = useState(30);

  return (
    <DashboardLayout>
      <div className="space-y-10">

        <h1 className="text-2xl font-serif">
          Production Request Simulation
        </h1>

        <div className="rounded-2xl bg-white/5 border border-white/10 p-6">

          <p className="text-sm text-gray-400 mb-4">
            Branch requests <b>{qty} Kg</b> of{" "}
            <span className="text-white font-medium">
              {sampleRecipe.product}
            </span>
          </p>

          <input
            type="number"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
            className="px-4 py-2 rounded-lg bg-black/40 border border-white/10 mb-6"
          />

          <h3 className="font-serif text-lg mb-4">
            Raw Materials Required (Auto-calculated)
          </h3>

          <ul className="space-y-3">
            {sampleRecipe.ingredients.map((i) => (
              <li
                key={i.item}
                className="flex justify-between rounded-lg bg-black/40 p-3"
              >
                <span>{i.item}</span>
                <span className="text-amber-400">
                  {(i.qty * qty).toFixed(2)} {i.unit}
                </span>
              </li>
            ))}
          </ul>

          <div className="mt-6 text-sm text-emerald-400">
            ✔ Raw materials will be auto-deducted from factory inventory  
            ✔ Production batch will be created automatically
          </div>

        </div>

      </div>
    </DashboardLayout>
  );
}
